import { useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";
import invariant from "ts-invariant";

import { useGetExercise } from "api/hooks/useGetExercise";
import type { ExerciseItem } from "api/services/content/schemas/exercises";
import { useProfileContext } from "contexts/ProfileContext";
import { PageContainer } from "routes/library/components";

import { ExercisePreview } from "./components";

type LocationState = {
  exercise?: ExerciseItem;
};

export const Exercise: React.FC = () => {
  const { id } = useParams();
  const { state } = useLocation() as { state: LocationState };
  const { profile } = useProfileContext();
  const [exercise, setExercise] = useState<ExerciseItem | undefined>(state?.exercise);

  invariant(profile, "Profile should be defined");

  const exerciseID = id ? parseInt(id, 10) : -1;
  const { data, isError, isLoading } = useGetExercise(exerciseID, profile.locale as string);

  useEffect(() => {
    if (data) {
      setExercise(data);
    }
  }, [data]);

  return (
    <PageContainer disableBlocking isError={isError} isLoading={isLoading}>
      {exercise && <ExercisePreview exercise={exercise} isEditable={exercise.creator_id === profile.id} />}
    </PageContainer>
  );
};
